<div class="fab-container">
  <button class="fab-button" [class.open]="isMenuOpen()" (click)="handleToggle()" type="button" aria-label="Toggle FAB Menu">
    <ion-icon name="menu-plus" class="fab-icon"></ion-icon>
  </button>
</div>
